/* ============================================================
   Griptec quick-add v2 — AJAX cart drawer + tight variant/pack modal.

   - (+) on a card with ONE variant and no packs  -> AJAX add 1, open drawer.
   - (+) on a card with multiple variants OR packs -> open the shared modal.
   - Modal / single adds / bundle-spotlight "Kit up" all route through the
     same add() flow, reusing Dawn's product-form.js renderContents pattern
     (cart-drawer.getSectionsToRender() -> formData sections + sections_url).

   No-JS fallback: card renders a real POST <form> / PDP link and the bundle
   spotlight keeps its plain form; this script progressively enhances them.

   Vanilla, no deps. Reduced-motion respected for the entrance.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dialog = null; // the one shared <dialog>, built on first use
  var lastTrigger = null; // element focus returns to on close
  var state = null; // { data, variantId, packId } for the open modal

  /* ---- add flow (reuse Dawn's product-form pattern) ---------- */
  function getCart() {
    return document.querySelector('cart-drawer');
  }

  // Add a variant id to the cart. Feature-detects the drawer; falls back to a
  // full navigation to the cart page when no drawer is on the page.
  function add(variantId, quantity, trigger, onDone) {
    var cart = getCart();
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity || 1);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(trigger || document.activeElement);
    }
    config.body = formData;

    return fetch(window.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // sold out / error — surface it on the trigger where we can
          if (typeof onDone === 'function') onDone(response);
          return;
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'griptec-quick-add',
            productVariantId: variantId,
            cartData: response,
          });
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response); // refreshes drawer sections + opens it
        if (typeof onDone === 'function') onDone(response);
      })
      .catch(function (e) {
        console.error(e); // eslint-disable-line no-console
        if (typeof onDone === 'function') onDone({ status: true });
      });
  }

  /* ---- money / helpers --------------------------------------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---- modal build (one shared element) ---------------------- */
  function buildDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = 'GriptecQuickAdd';
    dialog.className = 'gc-qa';
    dialog.setAttribute('aria-label', 'Quick add');
    dialog.innerHTML =
      '<div class="gc-qa__panel">' +
        '<div class="gc-qa__head">' +
          '<img class="gc-qa__thumb" alt="" width="72" height="72">' +
          '<p class="gc-qa__title"></p>' +
          '<button type="button" class="gc-qa__close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="gc-qa__opts" hidden></div>' +
        '<div class="gc-qa__packs" hidden>' +
          '<p class="gc-qa__packs-label">Buy a pack &mdash; save up to 30%</p>' +
          '<div class="gc-qa__chips"></div>' +
        '</div>' +
        '<div class="gc-qa__foot">' +
          '<span class="gc-qa__price">' +
            '<b class="gc-qa__now"></b>' +
            '<s class="gc-qa__was" hidden></s>' +
          '</span>' +
          '<button type="button" class="g-bundle__cta gc-qa__add">Add</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);

    // close: × button, backdrop click, Esc (native dialog cancel)
    dialog.querySelector('.gc-qa__close').addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); });
    dialog.addEventListener('click', function (e) {
      // backdrop = clicks on the <dialog> itself, not the inner panel
      if (e.target === dialog) closeDialog();
    });
    dialog.querySelector('.gc-qa__add').addEventListener('click', onAddClick);
    return dialog;
  }

  function closeDialog() {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-in');
    dialog.close();
    document.body.classList.remove('gc-qa-lock');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
    state = null;
  }

  /* ---- selection state --------------------------------------- */
  // Resolve the variant matching the currently picked option values.
  function currentVariant(data) {
    if (!data.options || !data.options.length) return data.variants[0];
    var picked = data._picked || [];
    return data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === picked[i]; });
    }) || null;
  }

  function activePackObj(data) {
    if (state.packId == null) return null;
    return (data.packs || []).find(function (p) { return String(p.variantId) === String(state.packId); }) || null;
  }

  function updateFoot() {
    var data = state.data;
    var now = dialog.querySelector('.gc-qa__now');
    var was = dialog.querySelector('.gc-qa__was');
    var addBtn = dialog.querySelector('.gc-qa__add');
    var chosen; // { price, compare, compareCents, priceCents, available, variantId }

    var pack = activePackObj(data);
    if (pack) {
      chosen = pack;
      state.variantId = null;
    } else {
      chosen = currentVariant(data);
      state.variantId = chosen ? chosen.id : null;
    }

    if (!chosen) {
      now.textContent = '';
      was.hidden = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
      return;
    }
    now.textContent = chosen.price;
    if (chosen.compareCents && chosen.compareCents > chosen.priceCents) {
      was.hidden = false;
      was.textContent = chosen.compare;
    } else {
      was.hidden = true;
    }
    addBtn.disabled = !chosen.available;
    addBtn.textContent = chosen.available ? 'Add' : 'Sold out';
  }

  /* ---- option pills (mirror .g-bundle__pill markup) ---------- */
  function renderOpts(data) {
    var wrap = dialog.querySelector('.gc-qa__opts');
    wrap.innerHTML = '';
    // only show option pills for genuinely multi-variant products
    if (data.variants.length < 2 || !data.options || !data.options.length) {
      wrap.hidden = true;
      data._picked = data.variants[0] ? data.variants[0].options.slice() : [];
      return;
    }
    wrap.hidden = false;
    // seed picks from first available variant
    var seed = data.variants.find(function (v) { return v.available; }) || data.variants[0];
    data._picked = seed.options.slice();

    data.options.forEach(function (opt, gi) {
      var group = el('fieldset', 'g-bundle__optgroup');
      var legend = el('legend', null, opt.name);
      group.appendChild(legend);
      var pills = el('div', 'g-bundle__pills');
      opt.values.forEach(function (val) {
        var label = el('label', 'g-bundle__pill');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'gc-qa-opt-' + gi;
        input.value = val;
        if (data._picked[gi] === val) input.checked = true;
        input.addEventListener('change', function () {
          data._picked[gi] = val;
          clearPackSelection();
          updateFoot();
        });
        var span = el('span', null, val);
        label.appendChild(input);
        label.appendChild(span);
        pills.appendChild(label);
      });
      group.appendChild(pills);
      wrap.appendChild(group);
    });
  }

  /* ---- pack chips (styled like pills) ------------------------ */
  function renderPacks(data) {
    var box = dialog.querySelector('.gc-qa__packs');
    var chips = dialog.querySelector('.gc-qa__chips');
    chips.innerHTML = '';
    if (!data.packs || !data.packs.length) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    data.packs.forEach(function (p) {
      var chip = el('button', 'g-bundle__pill gc-qa__chip');
      chip.type = 'button';
      chip.dataset.pack = p.variantId;
      chip.disabled = !p.available;
      var span = el('span');
      span.innerHTML = '<b>' + p.label + '</b> ' + p.price;
      chip.appendChild(span);
      chip.addEventListener('click', function () {
        if (String(state.packId) === String(p.variantId)) {
          clearPackSelection();
        } else {
          selectPack(p.variantId);
        }
        updateFoot();
      });
      chips.appendChild(chip);
    });
  }

  function selectPack(variantId) {
    state.packId = variantId;
    dialog.classList.add('gc-qa--pack'); // dims the single-buy option pills
    dialog.querySelectorAll('.gc-qa__chip').forEach(function (c) {
      c.classList.toggle('is-active', String(c.dataset.pack) === String(variantId));
    });
    // uncheck single-buy radios visually (they stay as the fallback variant)
    dialog.querySelectorAll('.gc-qa__opts input').forEach(function (r) { r.checked = false; });
  }

  function clearPackSelection() {
    state.packId = null;
    dialog.classList.remove('gc-qa--pack');
    dialog.querySelectorAll('.gc-qa__chip').forEach(function (c) { c.classList.remove('is-active'); });
    // restore radio checked-state from _picked
    var data = state.data;
    dialog.querySelectorAll('.gc-qa__opts .g-bundle__optgroup').forEach(function (group, gi) {
      group.querySelectorAll('input').forEach(function (r) {
        r.checked = r.value === data._picked[gi];
      });
    });
  }

  /* ---- open ---------------------------------------------------- */
  function openModal(data, trigger) {
    buildDialog();
    lastTrigger = trigger || null;
    state = { data: data, variantId: null, packId: null };

    var thumb = dialog.querySelector('.gc-qa__thumb');
    if (data.image) { thumb.src = data.image; thumb.hidden = false; } else { thumb.hidden = true; }
    dialog.querySelector('.gc-qa__title').textContent = data.title;

    renderOpts(data);
    renderPacks(data);
    updateFoot();

    document.body.classList.add('gc-qa-lock');
    dialog.showModal();
    if (!REDUCED) requestAnimationFrame(function () { dialog.classList.add('is-in'); });
    else dialog.classList.add('is-in');
    // focus into the panel (close button) on open
    dialog.querySelector('.gc-qa__close').focus();
  }

  function onAddClick() {
    var addBtn = dialog.querySelector('.gc-qa__add');
    if (addBtn.disabled) return;
    var id = state.packId != null ? state.packId : state.variantId;
    if (!id) return;
    addBtn.disabled = true;
    var original = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    add(id, 1, lastTrigger, function (response) {
      if (response && response.status) {
        addBtn.textContent = 'Sold out';
        return;
      }
      closeDialog(); // drawer is already opening via renderContents
    });
  }

  /* ---- (+) click delegation ---------------------------------- */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('.gc__quick');
    if (!quick) return;

    var wrapper = quick.closest('.card-wrapper') || quick.closest('.gc');
    if (!wrapper) return;
    var dataEl = wrapper.querySelector('.gc-qa-data');

    // Modal path: JSON payload present (multi-variant or packs exist).
    if (dataEl) {
      e.preventDefault();
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      openModal(data, quick);
      return;
    }

    // Single-variant direct add: hijack the fallback POST form.
    var form = quick.closest('.gc__quick-form');
    if (form) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      quick.disabled = true;
      add(idInput.value, 1, quick, function () { quick.disabled = false; });
    }
  });

  /* ---- bundle spotlight: progressively enhance its form ------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-gc-ajax-form]');
    if (!form) return;
    if (!getCart()) return; // no drawer -> let the plain POST proceed
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    add(idInput.value, qtyInput ? qtyInput.value : 1, btn, function (response) {
      if (btn) btn.disabled = false;
      if (response && response.status && btn) btn.disabled = true;
    });
  });
})();
